<template>
    <component :is="schema.options ? 'b-form-checkbox-group' : 'b-form-checkbox'" v-model="value" v-bind="{ ...schema, ...schema.attributes }"><span class="font-size-12 text-dark" v-html="schema.text"></span></component>
</template>

<script>
    import { abstractField } from "vue-form-generator";
    export default {
        mixins: [abstractField]
    };
</script>

<style></style>
